import { css } from "@styled-system/css";

export const backButtonClass = css({
	mt: "4",
});
